import { render, staticRenderFns } from "./performanceRecords.vue?vue&type=template&id=10e2c2f8&scoped=true&"
import script from "./performanceRecords.vue?vue&type=script&lang=js&"
export * from "./performanceRecords.vue?vue&type=script&lang=js&"
import style0 from "./performanceRecords.vue?vue&type=style&index=0&id=10e2c2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2c2f8",
  null
  
)

export default component.exports